import * as React from "react";
import { Stack } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import "./SyncUsersConfirmationModal.css";

const SyncUsersConfirmationModal = ({
  show,
  close,
  handleConfirmChange,
  OrgName,
}) => {
  return (
    <div>
      <Dialog
        open={show}
        onClose={close}
        sx={{
          backdropFilter: "blur(1px)",
          //other styles here
        }}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        {/* Dialog Title */}
        <DialogTitle id="scroll-dialog-title" sx={{ background: "white" }}>
          Confirm Action
        </DialogTitle>
        <DialogContent
          sx={{
            maxHeight: "calc(100% - 209px)",
            maxWidth: "40vw",
            minWidth: "30vw",
            color: "black",
            letterSpacing: "0.00938em",
          }}
        >
          <div style={{ marginBottom: "30px" }}>
            <div
              style={{
                listStyle: "none",
                marginTop: "5px",
                border: "1px solid lightgray",
                borderRadius: "3px",
                padding: "5px",
                paddingLeft: "10px",
                marginBottom: "5px",
                backgroundColor: "whitesmoke",
              }}
            >
              {"Are you are you want to start the sync process for the "}
              <strong>{OrgName}</strong>
              {" organization ?"}
            </div>
          </div>
          {/* <div style={{ marginBottom: "30px" }}>
            <div
              style={{
                listStyle: "none",
                marginTop: "5px",
                border: "1px solid lightgray",
                borderRadius: "3px",
                padding: "5px",
                paddingLeft: "10px",
                marginBottom: "5px",
                backgroundColor: "whitesmoke",
              }}
            >
              <strong role="orgName">{props.params.name} - </strong>
              <span role="orgEmail">{props.params.email}</span>
            </div>
          </div> */}

          <div style={{ marginTop: "20px" }}>
            <strong>Note: </strong>This is a background process, and time taken
            to complete sync may vary based on the number of users in the
            organization.
          </div>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Stack
            sx={{
              padding: "0.2rem 0rem",
              margin: "0 auto",
              alignContent: "center",
              justifyContent: "center",
            }}
            direction="row"
            spacing={5}
          >
            <Button
              sx={{
                backgroundColor: "white",
                border: "1px solid gray",
                letterSpacing: "0.5px",
                padding: "4px 16px",
                borderRadius: "3px",
                fontSize: "14px",
                color: "black",
              }}
              onClick={close}
            >
              Cancel
            </Button>
            <Button
              sx={{
                backgroundColor: "green",
                letterSpacing: "0.5px",
                padding: "4px 16px",
                borderRadius: "3px",
                fontSize: "14px",
                color: "white",
                "&:hover": {
                  backgroundColor: "#015e01",
                  color: "white",
                },
              }}
              onClick={handleConfirmChange}
            >
              Confirm
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SyncUsersConfirmationModal;
